

export enum LogType
{
    SUCCESS_OP = 1,
    APP_EXCEPTION = 2,
    FATAL_EXCEPTION = 3
}


export enum IdentityConformationState {

    NOT_CONFIRMED = 0,

    INFO_INVALID = 10,

    UPDATE_REQURED = 20,

    PENDING_CONFIRMATION = 30, // WHEN moving from NOT_CONFIRMED, INFO_INVALID, UPDATE_REQURED 

    UPDATE_UNDER_REVIEW = 40,// WHEN moving from CONFIRMED 

    CONFIRMED = 50,

}